angular
	.module 'App.Component'
	.component 'translatableInput',
		{
			templateUrl: '@component/input/translatable-input/translatable-input.view.html'
			controller: 'TranslatableInputComponent'
			controllerAs: 'input'
			bindings:
				required: '@?'
				type: '@?'
				entity: '<'
				attribute: '@'
				label: '@'
				id: '@?'
				required: '@?'
				disabled: '<?'
				errors: '<?'
				onChange: '&?'
		}

class TranslatableInputComponent extends AbstractController
	@register()
	@inject '$uibModal',
		'LanguageService'

	initialize: ->
		@disabled ?= false
		@required ?= false
		@type ?= 'text'
		@id ?= "#{@controllerId}-#{@attribute}"
		@required ?= false
		@baseLanguage = @LanguageService.getSystemLanguage().language
		@languages = @LanguageService.getLanguages()
		@initializeEntityTranslations()

	initializeEntityTranslations: ->
		@translations = {}

		if @entity.translations?
			for translation in @entity.translations
				language = _.find(@languages, {id: translation.language_id})

				if !language? || _.isEmpty(translation.value)
					continue

				@translations[language.language] ?= {}
				@translations[language.language][translation.label] = translation.value

		if !_.isEmpty(@entity[@attribute])
			@onMainInputChange()

	onMainInputChange: ->
		if @entity[@attribute] == null
			if @translations[@baseLanguage]?[@attribute]?
				delete @translations[@baseLanguage][@attribute]
		else
			@translations[@baseLanguage] ?= {}
			@translations[@baseLanguage][@attribute] = @entity[@attribute]

		@updateEntityTranslations()

	showTranslationsModal: ->
		@$uibModal
			.open
				templateUrl: '@component/input/translatable-input/modals/translatable-input.modal.view.html'
				controllerAs: 'inputModal'
				controller: (label, attribute, type, languages, displayLanguage, translations) ->
					$onInit: ->
						@label = label
						@attribute = attribute
						@type = type
						@languages = languages
						@translations = translations
						@selectedLanguage = displayLanguage

				changeLanguage: (language) ->
					@selectedLanguage = language
				resolve:
					label: => @label
					attribute: => @attribute
					type: => @type
					languages: => @languages
					displayLanguage: => @LanguageService.getDisplayLanguage()
					translations: => angular.copy @translations
			.result
			.then (translations) =>
				@translations = translations

				if !_.isEmpty(@translations[@baseLanguage]?[@attribute])
					@entity[@attribute] = @translations[@baseLanguage][@attribute]

				@updateEntityTranslations()

				if @onChange?
					@onChange({translations: translations})

	updateEntityTranslations: ->
		@entity.translations ?= []

		for language in @languages
			value = @translations[language.language]?[@attribute]
			translation = _.find(@entity.translations, {language_id: language.id, label: @attribute})

			if _.isEmpty(value)
				if translation?
					@entity.translations = _.reject(@entity.translations, translation)

				continue

			if translation?
				translation.value = value
			else
				@entity.translations.push({
					label: @attribute
					language_id: language.id
					value: value
				})
